/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { NestedEntryPointsMap } from '@jira/work-item__jsm-work-item-tabs/src/types/NestedEntryPointsMap.tsx';
import { overviewTabEntryPoint } from '@jira/work-item__jsm-incidents-overview-tab/src/overviewTabEntryPoint.entrypoint.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmIncidentsEntrypointProps } from './JsmIncidents.entrypoint.types.tsx';
import type { TabsConfig } from './TabsConfig.tsx';

const TAB_ENTRY_POINTS: TabsConfig = {
	overview: overviewTabEntryPoint,
} as const;

type PreloadedEntryPoints = Partial<TabsConfig>;

type JsmIncidentsEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	PreloadedEntryPoints,
	JsmIncidentsEntrypointProps,
	Record<string, never>
>;

export const jsmIncidentsEntryPoint: EntryPoint<JsmIncidentsEntryPointComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<JsmIncidentsEntryPointComponent>(
			/* webpackChunkName: "async-jsm-incidents" */ './JsmIncidents.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ activeTabKey }: EntryPointParams) => {
			const tabKey: keyof TabsConfig = isValidTabKey(activeTabKey) ? activeTabKey : 'overview';

			const entryPoints: NestedEntryPointsMap<TabsConfig> = {
				overview: undefined,
			};

			switch (tabKey) {
				case 'overview': {
					entryPoints.overview = {
						entryPoint: TAB_ENTRY_POINTS.overview,
						entryPointParams: {},
					};
					break;
				}
				default: {
					const _exhaustiveCheck: never = tabKey;
					throw new Error(`Invalid tab key: ${_exhaustiveCheck}`);
				}
			}

			return {
				entryPoints,
			};
		},
	});

type EntryPointParams = {
	activeTabKey: string;
};

const isValidTabKey = (key: string): key is keyof TabsConfig => {
	return Object.keys(TAB_ENTRY_POINTS).includes(key);
};
